import { fetchCart } from '@/services/cart/cart-api.service';
import { useVuexStore } from '@/store';
import type { Cart } from '@/types';
import { safePush } from '@/router';
import { ROUTENAMES } from '@/consts/const.enum';

export async function instaWPCB() {
  // Fetching cart to make sure we have the latest data
  await fetchCart();

  const store = useVuexStore();
  const cart: Cart = store.state.cart;

  const lastAddedItem = cart.items?.at(-1);
  const id = lastAddedItem?.id;

  if (lastAddedItem?.mossFlow.length) {
    await safePush({
      name: ROUTENAMES.OPTIONAL,
      query: { item: String(id) }
    });
  } else {
    await safePush({
      name: ROUTENAMES.CART
    });
  }
}
